const LINK_PROTOCOLS = new Set(["http:", "https:", "mailto:", "tel:"]);
const IMAGE_PROTOCOLS = new Set(["http:", "https:"]);

function decodeSchemeProbe(value: string): string {
    let decoded = value.trim();

    for (let iteration = 0; iteration < 3; iteration += 1) {
        decoded = decoded
            .replace(/&#(?:x([0-9a-f]+)|([0-9]+));?/gi, (_match, hex: string | undefined, decimal: string | undefined) => {
                const codePoint = Number.parseInt(hex ?? decimal ?? "", hex ? 16 : 10);

                return Number.isSafeInteger(codePoint) && codePoint >= 0 && codePoint <= 0x10ffff
                    ? String.fromCodePoint(codePoint)
                    : "";
            })
            .replace(/&colon;/gi, ":")
            .replace(/&(tab|newline);/gi, "");

        try {
            decoded = decodeURIComponent(decoded);
        } catch {
            break;
        }
    }

    return Array.from(decoded)
        .filter((character) => {
            const codePoint = character.codePointAt(0) ?? 0;

            return codePoint > 32 && codePoint !== 127 && !/\s/u.test(character);
        })
        .join("")
        .toLowerCase();
}

function safeUrl(value: unknown, allowedProtocols: ReadonlySet<string>): string | null {
    if (typeof value !== "string" || value.trim() === "") {
        return null;
    }

    const trimmed = value.trim();
    const normalized = decodeSchemeProbe(trimmed);
    const scheme = normalized.match(/^[a-z][a-z0-9+.-]*:/)?.[0];

    if (scheme && !allowedProtocols.has(scheme)) {
        return null;
    }

    return trimmed;
}

export function safeRichTextHref(value: unknown): string {
    return safeUrl(value, LINK_PROTOCOLS) ?? "#";
}

export function safeRichTextImageSrc(value: unknown): string | null {
    return safeUrl(value, IMAGE_PROTOCOLS);
}

export function safeRichTextColor(value: unknown): string | null {
    if (typeof value !== "string" || !/^#[0-9a-f]{3,8}$/i.test(value.trim())) {
        return null;
    }

    return value.trim();
}
